export default "__VITE_ASSET__008f0760__"